@for (item of placeholderArray; track item) {
  <app-report-tile [isPlaceholder]="true"></app-report-tile>
}
